import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { LineOfBusiness } from 'api/src/services/Constants';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../common/AdobeTagging/adobeLinkTrackEvent';
import { StyledFooterAlignRight } from '../../../common/ConstantsStyles';
import { CountyStateSelectInput } from '../../../common/CountyStateSelectInput';
import { useLagoon } from '../../../hooks/useLagoon';
import { GeospatialModalContainer } from './GeospatialModal.style';

type GeospatialModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSearch: () => void;
  selectedCounty: string;
  setSelectedCounty: (value: string) => void;
  lob: string;
  usPostalPointId: string;
};

export const GeospatialModal = ({
  isOpen,
  onClose,
  onSearch,
  selectedCounty,
  setSelectedCounty,
  lob,
  usPostalPointId,
}: GeospatialModalProps) => {
  const lagoonConfig = useLagoon('config');
  const planSelectionConfig =
    typeof lagoonConfig === 'function' ? lagoonConfig() : lagoonConfig;
  const lagoonSignInUrl = planSelectionConfig?.find(
    (row) => row.key === `SIGNIN_URL_${lob?.toUpperCase()}`
  )?.value;
  const locationModalAdobeLabel = 'select county/state modal';
  const { t } = useTranslation();

  return (
    <GeospatialModalContainer
      closeOnClickOutside={false}
      footer={
        <StyledFooterAlignRight>
          <Layout.Group style={{ gap: 8 }}>
            <Button
              data-auto-testid="modal-search-button"
              data-testid="modal-search-button"
              isDisabled={!selectedCounty}
              onClick={onSearch}
              size="$md"
              type="button"
            >
              {t('GUEST_COUNTY_STATE_MODAL.SEARCH')}
            </Button>
            <Button
              css={{ marginLeft: '8px' }}
              data-auto-testid="modal-sign-in-button"
              data-testid="modal-sign-in-button"
              href={lagoonSignInUrl || ''}
              onClick={() => {
                adobeLinkTrackEvent({
                  name: 'sign in',
                  location: locationModalAdobeLabel,
                  type: 'internal',
                  destinationUrl: lagoonSignInUrl || '',
                });
              }}
              size="$md"
              variant="outline"
            >
              {t('GUEST_COUNTY_STATE_MODAL.SIGN_IN')}
            </Button>
          </Layout.Group>
        </StyledFooterAlignRight>
      }
      header={
        <span
          data-auto-testid="geospatial-modal-heading"
          data-testid="geospatial-modal-heading"
        >
          {lob === LineOfBusiness.MR
            ? t('GUEST_COUNTY_STATE_MODAL.SELECT_COUNTY')
            : t('GUEST_COUNTY_STATE_MODAL.SELECT_STATE')}
        </span>
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      <Text
        // css={{ marginBottom: '8px' }}
        data-auto-testid="geospatial-modal-subheading"
        data-testid="geospatial-modal-subheading"
      >
        {lob === LineOfBusiness.MR
          ? t('GUEST_COUNTY_STATE_MODAL.HEADING_COUNTY')
          : t('GUEST_COUNTY_STATE_MODAL.HEADING_STATE')}
      </Text>

      <CountyStateSelectInput
        data-auto-testid="geospatial-county-dropdown"
        data-testid="geospatial-county-dropdown"
        isCountyList={lob === LineOfBusiness.MR}
        onChange={setSelectedCounty}
        selectedValue={selectedCounty}
        show
        usPostalPointId={usPostalPointId}
        width={300}
      />
    </GeospatialModalContainer>
  );
};
